import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Interview from '../../../../assets/images/Interview.png';
import { ImgWebp } from '../../ImgWeb';
import { ButtonClassNames, CookieItems } from '../../../../models/Common';
import { CustomMUIButton } from '../../buttons/CustomMUIButton';
import { brizTvInterviewBonusAmount, brizTvInterviewLink } from '../../../../constants/configuration';

interface InterviewRegistrationProps {
  handleClose: () => void;
  userId: number;
}

export const InterviewRegistration: FC<InterviewRegistrationProps> = ({ handleClose, userId }) => {
  const { t } = useTranslation();
  const [, setCookie] = useCookies();

  const setCookieAndCloseWindow = () => {
    setCookie(`${CookieItems.INTERVIEW}_${userId}`, userId, { path: '/', maxAge: 86400 * 90 });
    handleClose();
  };

  return (
    <div className="modals">
      <div className="modals__header modals__header__interview">
        <ImgWebp fallback={Interview} alt="signature" className="img-interview" />
        <article className="modals__header__title">{t('modals.hello')}</article>
        <p className="modals__header__description">{t('modals.interviewQuestion')}</p>
        <p className="modals__header__description">
          {t('modals.interviewBonuses', { val: brizTvInterviewBonusAmount })}
        </p>
        <p className="modals__header__description">{t('modals.interviewThankYou')}</p>
      </div>
      <div className="modals__btn-group">
        <Link to={{ pathname: brizTvInterviewLink }} target="_blank">
          <CustomMUIButton
            label={t('buttons.register')}
            handleClick={setCookieAndCloseWindow}
            className={ButtonClassNames.PrimaryFulfilled}
            isBold
          />
        </Link>
      </div>
    </div>
  );
};
